import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ComparisonToggleInput,
    ToggleComparison as ToggleComparisonMutation,
    ToggleComparisonVariables as ToggleComparisonMutationVariables,
} from 'nutshell-graphql-types';

import EDITION_FRAGMENT from '../fragments/edition-basic-fragment.graphql';
import TOGGLE_COMPARISON from '../mutations/toggle-comparison.graphql';

export function useToggleComparison(): {
    toggleComparison: (arg1: ComparisonToggleInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [toggleComparison, {loading, error}] = useMutation<
        ToggleComparisonMutation,
        ToggleComparisonMutationVariables
    >(TOGGLE_COMPARISON);

    return {
        toggleComparison: (input: ComparisonToggleInput) =>
            toggleComparison({
                variables: {input},
                update: (proxy, mutationResults) => {
                    const updatedEdition =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.comparisonToggle &&
                        mutationResults.data.comparisonToggle.edition;

                    if (!updatedEdition) return;

                    proxy.writeFragment({
                        id: input.editionId,
                        fragment: EDITION_FRAGMENT,
                        fragmentName: 'EditionBasicFragment',
                        data: {
                            ...updatedEdition,
                        },
                    });
                },
            }).then(
                (result) =>
                    result &&
                    result.data &&
                    result.data.comparisonToggle &&
                    result.data.comparisonToggle.edition
            ),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
